<template>
  <div>
    <el-form label-width="100px">
      <el-row type="flex" justify="space-between" class="flex-wrap-wrap">
        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
          <el-form-item label="终端：">
            <span v-if="!spores || !spores.length">暂无数据</span>
            <span v-else-if="spores && spores.length === 1">
              {{ spores[0].name }}
            </span>
            <el-select
              v-else
              v-model="deviceId"
              clearable
              placeholder="请选择"
              style="width:100%;"
            >
              <el-option
                v-if="teles.length > 1"
                label="全部"
                :value="null"
              ></el-option>
              <el-option
                v-for="device in spores"
                :key="device.id"
                :label="device.name"
                :value="device.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
          <el-form-item label="起始日期：">
            <el-date-picker
              v-model="beginDate"
              type="date"
              placeholder="选择日期"
              style="width:100%;"
              :picker-options="pickOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
          <el-form-item label="结束日期：">
            <el-date-picker
              v-model="endDate"
              type="date"
              placeholder="选择日期"
              style="width:100%;"
              :picker-options="pickOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" class="text-right">
          <el-button type="primary" :loading="loading" @click="goSearch">
            查询
          </el-button>
          <el-button @click="resetSearch" :loading="loading">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { datePickOption } from '@/utlis/mixin'
import { weekBegin, formatDate } from '@/utlis/date'

export default {
  mixins: [datePickOption],
  props: { loading: Boolean },
  data() {
    return {
      beginDate: weekBegin(),
      endDate: formatDate(undefined, 'YYYY-MM-DD'),
      deviceId: null
    }
  },
  methods: {
    resetSearch() {
      this.beginDate = undefined
      this.endDate = undefined
      this.deviceId = null
      if (this.spores && this.spores[0]) {
        this.goSearch()
      }
    },
    goSearch() {
      const { beginDate, endDate, deviceId } = this
      this.$emit('change', {
        beginDate,
        endDate,
        deviceId,
        companyId: this.companyId
      })
    }
  }
}
</script>

<style lang="css" scoped></style>
